/*
 * Yugen Community Showcase — "Built by Builders"
 * One customer story at a time with crossfade + subtle image zoom, Prev/Next
 * controls, clickable progress dots, and mobile swipe. No scroll-jacking, no
 * external libraries. Scoped to the <yugen-community-showcase> custom element.
 */
(function () {
  'use strict';

  var SWIPE_THRESHOLD = 45;

  class YugenCommunityShowcase extends HTMLElement {
    constructor() {
      super();
      this.index = 0;
      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);
      this.onDotClick = this.onDotClick.bind(this);
      this.onTouchStart = this.onTouchStart.bind(this);
      this.onTouchMove = this.onTouchMove.bind(this);
      this.onTouchEnd = this.onTouchEnd.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);
    }

    connectedCallback() {
      this.stories = Array.from(this.querySelectorAll('[data-ycs-story]'));
      this.dots = Array.from(this.querySelectorAll('[data-ycs-dot]'));
      this.prevBtn = this.querySelector('[data-ycs-prev]');
      this.nextBtn = this.querySelector('[data-ycs-next]');
      this.stage = this.querySelector('[data-ycs-stage]');

      if (this.stories.length === 0) return;

      if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);
      this.dots.forEach((dot) => dot.addEventListener('click', this.onDotClick));

      if (this.stage) {
        this.stage.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.stage.addEventListener('touchmove', this.onTouchMove, { passive: true });
        this.stage.addEventListener('touchend', this.onTouchEnd, { passive: true });
      }

      this.addEventListener('shopify:block:select', this.onBlockSelect);

      this.setActive(0);
    }

    disconnectedCallback() {
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this.onNext);
      if (this.dots) this.dots.forEach((dot) => dot.removeEventListener('click', this.onDotClick));
      if (this.stage) {
        this.stage.removeEventListener('touchstart', this.onTouchStart);
        this.stage.removeEventListener('touchmove', this.onTouchMove);
        this.stage.removeEventListener('touchend', this.onTouchEnd);
      }
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    onPrev() {
      this.setActive(this.index - 1);
    }

    onNext() {
      this.setActive(this.index + 1);
    }

    onDotClick(event) {
      var i = parseInt(event.currentTarget.getAttribute('data-ycs-dot'), 10);
      if (!isNaN(i)) this.setActive(i);
    }

    onBlockSelect(event) {
      var story = event.target.closest('[data-ycs-story]');
      var i = story ? this.stories.indexOf(story) : -1;
      if (i !== -1) this.setActive(i);
    }

    onTouchStart(event) {
      var t = event.changedTouches[0];
      this.touchStartX = t.clientX;
      this.touchStartY = t.clientY;
      this.touchDX = 0;
      this.touchDY = 0;
    }

    onTouchMove(event) {
      if (this.touchStartX == null) return;
      var t = event.changedTouches[0];
      this.touchDX = t.clientX - this.touchStartX;
      this.touchDY = t.clientY - this.touchStartY;
    }

    onTouchEnd() {
      if (this.touchStartX == null) return;
      var dx = this.touchDX || 0;
      var dy = this.touchDY || 0;
      if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy) * 1.4) {
        this.setActive(this.index + (dx < 0 ? 1 : -1));
      }
      this.touchStartX = null;
      this.touchStartY = null;
    }

    setActive(next) {
      var max = this.stories.length - 1;
      var i = Math.max(0, Math.min(next, max));
      this.index = i;

      this.stories.forEach(function (story, idx) {
        var active = idx === i;
        story.classList.toggle('is-active', active);
        story.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.dots.forEach(function (dot, idx) {
        var active = idx === i;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });

      if (this.prevBtn) this.prevBtn.disabled = i === 0;
      if (this.nextBtn) this.nextBtn.disabled = i === max;
    }
  }

  if (!customElements.get('yugen-community-showcase')) {
    customElements.define('yugen-community-showcase', YugenCommunityShowcase);
  }
})();
